<template>
    <div id="requestPettyCashComponent">
      <page-title :heading="heading" :subheading=subheading :icon=icon></page-title>
      <v-container>
        <v-layout wrap>

          <v-flex>
            <v-alert icon="monetization_on" :value="true" color="primary" outline >
              <h3 class="mb-0">
                <span class="font-weight-black">{{ $t('pettyCash.pettyCash') }}:</span>
                {{ pettyCashAmount | formatCurrency }} ({{ tagMoneda }})
              </h3>
            </v-alert>
          </v-flex>
          <v-flex text-sm-right>
            <v-btn @click="openCreate" color="primary" outline round>
              <v-icon  left>attach_money</v-icon> {{$t('pettyCash.requestPettyCash')}}
            </v-btn>
          </v-flex>
        </v-layout>

        <b-tabs pills active-nav-item-class="primary" lazy v-model="tabIndex">
          <b-tab
            v-for="tab in tabs"
            :key="tab.status"
            :disabled="loadingItems && statusTag !== tab.status"
            @click="getPettyCashByStatus(tab)"
          >
            <template v-slot:title>
              <h5 class="my-0">{{ tab.text }}</h5>
            </template>
            <v-flex>
              <v-toolbar flat color="bg-sidebar" dark>
                <h2 class="my-0">{{ tab.text }}</h2>
                <v-spacer></v-spacer>
                <v-text-field
                  color="light"
                  v-model="userSearch"
                  :label="$t('general.search')"
                  append-outer-icon="search"
                  clearable>
                </v-text-field>
              </v-toolbar>
              <v-data-table
              :search="userSearch"
              class="elevation-2 mt-2"
              :headers="tableHeaders"
              :items="pettyCash"
              :loading="loadingItems"
              :rows-per-page-items="[10,15,25]"
              :pagination.sync="pagination"
              >
                <template v-slot:headers="props">
                  <tr class="bg-heavy-rain">
                    <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                      @click="changeSort(header.value)"
                    >
                      <h2 class="font-weight-black primary--text mb-0">
                        <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                        {{header.text}}</h2>
                    </th>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <tr>
                    <td class="text-sm-center">
                      <!-- El último movimiento del progreso manda: si es un
                           rechazo se marca la solicitud con el motivo. -->
                      <v-layout v-if="isRejected(props.item)" justify-center>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon class="error--text" v-on="on">mdi-flag</v-icon>
                          </template>
                          <span>{{ rejectedMessage(props.item) }}</span>
                        </v-tooltip>
                      </v-layout>
                      {{props.item.id}}
                    </td>
                    <td class="text-sm-center">{{props.item.date}}</td>
                    <td v-if="showEmployeeColumn" class="text-sm-center">{{employeeName(props.item)}}</td>
                    <td class="text-sm-center">{{props.item.description}}</td>
                    <td class="text-sm-center">{{projectName(props.item)}}</td>
                    <td class="text-sm-center">{{props.item.amount | formatCurrency}}</td>
                    <td class="text-sm-center text-justify">
                      <!-- El seguimiento aplica en cualquier estatus; enviar a
                           validar, editar y eliminar sólo mientras está creada. -->
                      <v-layout row justify-center>
                        <v-tooltip v-if="tab.status === 'created'" top>
                          <template v-slot:activator="{ on }">
                            <v-btn @click="sendValidation(props.item)" v-on="on" color="info" outline small icon>
                              <v-icon small>play_arrow</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('expenses.sendValidation') }}</span>
                        </v-tooltip>
                        <v-tooltip v-if="tab.status === 'created'" top>
                          <template v-slot:activator="{ on }">
                            <v-btn @click="editItem(props.item)" v-on="on" color="info" outline small icon>
                              <v-icon small>edit</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('general.edit') }}</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn @click="watchHistory(props.item)" v-on="on" color="info" outline small icon>
                              <v-icon small>history</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('general.history') }}</span>
                        </v-tooltip>
                        <v-tooltip v-if="tab.status === 'created'" top>
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on" @click="removePetty(props.item)" color="error" outline small icon>
                              <v-icon small>delete</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('general.remove') }}</span>
                        </v-tooltip>
                      </v-layout>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </b-tab>
        </b-tabs>
        <v-dialog v-model="createDialog" max-width="600px" persistent>
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">{{ formTitle }}</h2>
            </v-toolbar>
            <v-card-text>
              <v-form lazy-validation ref="form" v-model="valid">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                      <v-select v-model="editedItem.isPettyCash" :items="requestType" :disabled="true" required :label="$t('general.type')" item-value="id" item-text="name" :rules="rules.required" :error-messages="errors.is_amex">
                      </v-select>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-autocomplete v-model="editedItem.core_user_id" :label="$t('general.employee')" :items="employeeItems" :disabled="editedIndex > -1" required :rules="rules.required" :error-messages="errors.core_user_id" item-value="id" item-text="name"></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-autocomplete v-model="editedItem.project_id" :label="$t('general.project')" :items="projects" required :rules="rules.required" :error-messages="errors.project_id" item-value="id" item-text="name"></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-text-field v-model="editedItem.description" :rules="rules.required" :label="$t('general.description')" :error-messages="errors.description" clearable required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12 class="currency-field">
                      <v-text-field v-model="editedItem.amount" :label="$t('restriction.rt.amount')" :rules="rules.decimalMax2" :error-messages="errors.amount" required type="number" prepend-icon="attach_money" clearable></v-text-field>
                      <span class="currency-tag">{{ tagMoneda }}</span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="close" color="primary" flat round>{{$t('general.cancel')}}</v-btn>
              <v-btn @click="validate()" :loading="loading" :disabled="loading" color="primary" depressed round>{{$t('general.save')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="validationDialog" max-width="500px">
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">{{ $t('expenses.sendValidation') }}</h2>
            </v-toolbar>
            <v-card-text class="text-sm-justify">
              <p>{{ $t('pettyCash.requestPettyCashValidationQuestion') }}</p>
              <p class="font-weight-black"><span class="primary--text">{{ $t('general.description') }}: </span>{{validatedItem.description}}</p>
              <p class="font-weight-black mb-0"><span class="primary--text">{{ $t('pettyCash.amount') }}: </span>{{validatedItem.amount | formatCurrency}}</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="close" color="primary darken-1" round flat>
                {{ $t('general.cancel') }}
              </v-btn>
              <v-btn @click="startValidation(validatedItem)" :loading="loading" :disabled="loading" color="primary" round depressed>
                {{ $t('general.submit') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="removeDialog" max-width="500px">
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black error--text mb-0">{{ $t('pettyCash.requestPettyCashRemove') }}</h2>
            </v-toolbar>
            <v-card-text class="text-sm-justify">
              <p>{{ $t('pettyCash.requestPettyCashRemoveQuestion') }}</p>
              <p class="font-weight-black"><span class="error--text">{{ $t('general.description') }}: </span>{{removedItem.description}}</p>
              <p class="font-weight-black mb-0"><span class="error--text">{{ $t('pettyCash.amount') }}: </span>{{removedItem.amount | formatCurrency}}</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="close" color="error darken-1" round flat>
                {{ $t('general.cancel') }}
              </v-btn>
              <v-btn @click="deletePetty(removedItem)" :loading="loading" :disabled="loading" color="error" round depressed>
                {{ $t('general.delete') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog persistent v-model="historyDialog" max-width="900px">
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">
                {{ $t('pettyCash.requestPettyCashTracking') }}
              </h2>
            </v-toolbar>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs6>
                  <h3>
                    <span class="primary--text font-weight-black">{{ $t('general.folio') }}: </span>{{ itemHistory.id }}
                  </h3>
                </v-flex>
                <v-flex xs6>
                  <h3>
                    <span class="primary--text font-weight-black">{{ $t('pettyCash.amount') }}: </span>{{ itemHistory.amount | formatCurrency }}
                  </h3>
                </v-flex>
                <v-flex xs6>
                  <h3>
                    <span class="primary--text font-weight-black">{{ $t('general.description') }}: </span>{{ itemHistory.description }}
                  </h3>
                </v-flex>
                <v-flex xs6>
                  <h3>
                    <span class="primary--text font-weight-black">{{ $t('general.date') }}: </span>{{ itemHistory.date }}
                  </h3>
                </v-flex>
                <!-- project_id puede no venir: sin proyecto no se pinta el renglón. -->
                <v-flex v-if="projectName(itemHistory)" xs6>
                  <h3>
                    <span class="primary--text font-weight-black">{{ $t('general.project') }}: </span>{{ projectName(itemHistory) }}
                  </h3>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <v-divider />
                  <h3 class="primary--text font-weight-black">
                    {{ $t('expenses.progress') }}:
                  </h3>
                  <v-card flat color="grey lighten-3">
                    <!-- Encabezado del flujo: una columna por estatus de progress. -->
                    <v-layout>
                      <template v-for="(step, index) in historySteps">
                        <v-divider v-if="index > 0" :key="step.key + '-step-divider'" vertical />
                        <v-flex :key="step.key + '-step'" class="text-center py-3" :class="step.done ? 'hist-steps white--text' : 'grey--text'" xs3>
                          <v-avatar class="mr-2" size="20" :color="step.done ? 'white' : 'grey'">
                            <v-icon v-if="step.done" class="font-weight-black" small>check</v-icon>
                            <span v-else class="white--text font-weight-black">{{ index + 1 }}</span>
                          </v-avatar>
                          <span class="font-weight-black my-3">{{ step.text }}</span>
                        </v-flex>
                      </template>
                    </v-layout>
                    <v-divider class="my-0 primary" />
                    <!-- Detalle. Los pasos ya firmados salen de progress; los
                         pendientes, del flujo de validación del solicitante
                         (api/workflow-validator-approver/{user_id}). -->
                    <v-layout v-if="histLoading">
                      <v-flex class="text-center pa-3">
                        <v-progress-circular color="primary" indeterminate size="50" />
                      </v-flex>
                    </v-layout>
                    <v-layout v-else>
                      <!-- CREADA -->
                      <v-flex class="text-center pa-3" xs3>
                        <template v-if="histSteps.created.length > 0">
                          <h3 class="primary--text font-weight-black">
                            {{ $t('pettyCash.progress.created') }}:
                          </h3>
                          <li v-for="progress of histSteps.created" :key="progress.id" class="text-sm-left">
                            {{ progressLabel(progress, 'created') }}
                          </li>
                        </template>
                        <h3 v-else class="grey--text font-weight-black py-2">
                          {{ $t('expenses.history.pending') }}
                        </h3>
                      </v-flex>
                      <!-- ENVIADA: quien envía es el mismo solicitante, así que
                           mientras la solicitud sigue creada (status 1) se
                           repite en gris; al enviarse (status 2) el paso ya
                           trae su propio movimiento. -->
                      <v-divider class="primary" vertical />
                      <v-flex class="text-center pa-3" xs3>
                        <template v-if="histSteps.sented.length > 0">
                          <h3 class="primary--text font-weight-black">
                            {{ $t('pettyCash.progress.sented') }}:
                          </h3>
                          <li v-for="progress of histSteps.sented" :key="progress.id" class="text-sm-left">
                            {{ progressLabel(progress, 'sented') }}
                          </li>
                        </template>
                        <template v-else-if="histSteps.created.length > 0">
                          <h3 class="grey--text font-weight-black py-2">
                            {{ $t('expenses.history.pending') }}
                          </h3>
                          <li v-for="progress of histSteps.created" :key="progress.id" class="text-sm-left grey--text">
                            {{ progressUserName(progress, 'created') }}
                          </li>
                        </template>
                        <h3 v-else class="grey--text font-weight-black py-2">
                          {{ $t('expenses.history.pending') }}
                        </h3>
                      </v-flex>
                      <!-- REVISADA: un renglón por validador del flujo, en orden.
                           Los que ya firmaron salen con la fecha de su
                           movimiento; los que faltan, en gris con su sustituto. -->
                      <v-divider class="primary" vertical />
                      <v-flex class="text-center pa-3" xs3>
                        <template v-if="validatorSteps.length > 0">
                          <h3 class="font-weight-black py-2" :class="reviewedDone ? 'primary--text' : 'grey--text'">
                            {{ reviewedDone ? $t('pettyCash.progress.reviewed') + ':' : $t('expenses.history.pending') }}
                          </h3>
                          <ul v-for="step of validatorSteps" :key="step.validator.id" class="text-sm-left">
                            <h6 class="text-center font-weight-black" :class="step.done ? '' : 'grey--text'">
                              {{ $t('validator.name') }} {{ step.validator.validatorId }}
                            </h6>
                            <li class="text-sm-left" :class="step.done ? '' : 'grey--text'">
                              {{ step.label }}
                            </li>
                            <template v-if="!step.done && step.substituteName">
                              <h6 class="text-center grey--text pt-1">
                                {{ $t('general.substitutes') }}
                              </h6>
                              <li class="text-sm-left grey--text">
                                {{ step.substituteName }}
                              </li>
                            </template>
                          </ul>
                        </template>
                        <!-- Sin flujo configurado (o todavía sin cargar): se
                             listan los movimientos de revisión tal cual. -->
                        <template v-else-if="histSteps.reviewed.length > 0">
                          <h3 class="primary--text font-weight-black">
                            {{ $t('pettyCash.progress.reviewed') }}:
                          </h3>
                          <li v-for="progress of histSteps.reviewed" :key="progress.id" class="text-sm-left">
                            {{ progressLabel(progress, 'reviewed') }}
                          </li>
                        </template>
                        <h3 v-else class="grey--text font-weight-black py-2">
                          {{ $t('expenses.history.pending') }}
                        </h3>
                      </v-flex>
                      <!-- APROBADA: aprobadores del flujo -->
                      <v-divider class="primary" vertical />
                      <v-flex class="text-center pa-3" xs3>
                        <template v-if="histSteps.approved.length > 0">
                          <h3 class="primary--text font-weight-black">
                            {{ $t('pettyCash.progress.approved') }}:
                          </h3>
                          <li v-for="progress of histSteps.approved" :key="progress.id" class="text-sm-left">
                            {{ progressLabel(progress, 'approved') }}
                          </li>
                        </template>
                        <!-- Completada sin movimiento de aprobación: la firma es
                             del aprobador configurado en el flujo. -->
                        <template v-else-if="isCompleted && approvers.length > 0">
                          <h3 class="primary--text font-weight-black">
                            {{ $t('pettyCash.progress.approved') }}:
                          </h3>
                          <li v-for="approver of approvers" :key="approver.id" class="text-sm-left">
                            {{ approverName(approver) }}
                          </li>
                        </template>
                        <template v-else-if="approvers.length > 0">
                          <h3 class="grey--text font-weight-black py-2">
                            {{ $t('expenses.history.pending') }}
                          </h3>
                          <ul v-for="approver of approvers" :key="approver.id">
                            <li class="text-sm-left grey--text">
                              {{ approverName(approver) }}
                            </li>
                          </ul>
                        </template>
                        <h3 v-else class="grey--text font-weight-black py-2">
                          {{ $t('expenses.noApproverDefault') }}
                        </h3>
                      </v-flex>
                    </v-layout>
                  </v-card>
                  <!-- El depósito ocurre después de la aprobación y no es un
                       paso del flujo: se anuncia como leyenda. -->
                  <div v-if="histSteps.deposited.length > 0" class="text-center pt-3">
                    <v-chip class="hist-steps white--text font-weight-black" text-color="white" small>
                      <v-icon class="mr-1 white--text" small>check_circle</v-icon>
                      {{ $t('pettyCash.progress.deposited') }}
                    </v-chip>
                    <div v-for="progress of histSteps.deposited" :key="progress.id" class="primary--text">
                      {{ progressLabel(progress, 'deposited') }}
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" round flat @click="close">
                {{ $t('general.close') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
</template>

<script>
export default {
  name: 'requestPettyCashComponent',
  data () {
    return {
      tagMoneda: '',
      settings: {},
      currencySetting: {},
      userSearch: '',
      errors: {},
      createDialog: false,
      historyDialog: false,
      removeDialog: false,
      validationDialog: false,
      loading: false,
      loadingItems: true,
      valid: true,
      pagination: {
        sortBy: 'id',
        descending: true,
        page: 1,
        rowsPerPage: 1000, // -1 for All",
        totalItems: 0
      },
      itemHistory: {},
      defaultHistory: {},
      // Flujo de validación del solicitante: pasos (validadores) y aprobadores.
      histLoading: false,
      validators: [],
      approvers: [],
      // Catálogo del select de empleado (api/petty-cash/users).
      employees: [],
      // Catálogo del select de proyecto (proyectos activos de la empresa).
      projects: [],
      pettyCash: [],
      editedIndex: -1,
      editedItem: {
        core_user_id: null,
        project_id: null,
        description: '',
        amount: '',
        isPettyCash: 1
      },
      removedItem: {
        id: null,
        core_user_id: null,
        description: '',
        amount: ''
      },
      defaultRemoved: {
        id: null,
        core_user_id: null,
        description: '',
        amount: ''
      },
      validatedItem: {
        id: null,
        description: '',
        amount: ''
      },
      defaultValidated: {
        id: null,
        description: '',
        amount: ''
      },
      defaultItem: {
        core_user_id: null,
        project_id: null,
        description: '',
        amount: '',
        isPettyCash: 1
      },
      requestType: [
        { name: this.$t('pettyCash.title'), id: 1 }
      ],
      tabIndex: 0,
      // Tab activo. Los estatus del tab viajan en cada get/refresh; un tab puede
      // agrupar más de uno (enviadas = enviada y en revisión).
      statusTag: 'created',
      statusIds: [1]
    }
  },
  computed: {
    heading () {
      return this.$t('pettyCash.requestPettyCash')
    },
    subheading () {
      return this.$t('pettyCash.subtitle')
    },
    icon () {
      return 'fa fa-wallet fa-fw icon-color'
    },
    // El saldo mostrado es el de la caja chica (type 1) del usuario logueado.
    pettyCashAmount () {
      const userLogged = this.$store.state.userLogged
      if (!userLogged || !userLogged.small_box) return 0

      const found = userLogged.small_box.find(x => x.type === 1)

      return found ? found.amount : 0
    },
    // La columna de empleado sólo tiene sentido cuando se puede capturar a
    // nombre de alguien más: si el catálogo sólo trae al usuario logueado (no
    // es representante de nadie) todas las solicitudes son suyas y sobra.
    showEmployeeColumn () {
      return this.employeeItems.length > 1
    },
    // Mismas columnas en todos los tabs: el seguimiento se puede consultar
    // siempre, lo que cambia es qué botones se pintan en la columna de acciones.
    tableHeaders () {
      const headers = [
        {
          text: '#',
          align: 'center',
          sortable: false
        },
        {
          text: this.$t('general.date'),
          align: 'center',
          value: 'created_at',
          sortable: false
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: false
        },
        {
          text: this.$t('general.project'),
          align: 'center',
          value: 'project_id',
          sortable: false
        },
        {
          text: this.$t('restriction.rt.amount'),
          align: 'center',
          value: 'amount',
          sortable: false
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]

      if (this.showEmployeeColumn) {
        headers.splice(2, 0, {
          text: this.$t('general.employee'),
          align: 'center',
          value: 'user_id',
          sortable: false
        })
      }

      return headers
    },
    // El select ofrece a los empleados activos del catálogo de caja chica. El
    // solicitante llega precargado, pero puede capturarse a nombre de otro.
    employeeItems () {
      const employees = this.employees.filter(x => x.active === 1)
      const userLogged = this.$store.state.userLogged
      if (!userLogged || !userLogged.id) return employees
      // El catálogo llega asíncrono y el usuario logueado puede no venir en él:
      // se agrega para que el valor por defecto siempre tenga etiqueta.
      if (employees.some(x => x.id === userLogged.id)) return employees
      return [{ id: userLogged.id, name: userLogged.name }].concat(employees)
    },
    tabs () {
      return [
        { status: 'created', statusIds: [1], text: this.$t('expenses.status.created') },
        // Enviadas agrupa las que siguen en el flujo de validación: 2 (enviada)
        // y 3 (por validar).
        { status: 'sented', statusIds: [2, 3], text: this.$t('expenses.status.sented') },
        { status: 'completed', statusIds: [6], text: this.$t('expenses.status.paid') }
      ]
    },
    // Movimientos de progress agrupados por paso. El estatus de texto sólo
    // alcanza para 'Creada' y 'Enviada'; el resto se resuelve contra el flujo
    // (ver progressStepKey), porque los movimientos de los validadores no
    // llegan marcados como 'Revisada'.
    histSteps () {
      const steps = { created: [], sented: [], reviewed: [], approved: [], deposited: [] }
      const progress = this.itemHistory.progress || []
      progress.forEach(item => {
        const key = this.progressStepKey(item)
        if (steps[key]) steps[key].push(item)
      })
      return steps
    },
    // Un renglón por validador del flujo, en el orden en que firman. Cuando el
    // validador (o su sustituto) ya tiene movimiento se marca como firmado y se
    // acompaña de la fecha; si no, queda pendiente.
    validatorSteps () {
      return this.validators.map(validator => {
        const sign = this.histSteps.reviewed.find(item => this.matchValidator(validator, item.user_id))
        const name = sign
          ? this.progressUserName(sign, 'reviewed')
          : (validator.validator ? validator.validator.user.name : '')
        return {
          validator: validator,
          // Una solicitud aprobada ya pasó por todos los validadores aunque el
          // backend no haya registrado el movimiento de cada uno.
          done: sign !== undefined || this.isApproved,
          label: sign ? (name ? name + ' - ' + sign.created_at : sign.created_at) : name,
          substituteName: validator.substitutes ? validator.substitutes.user.name : ''
        }
      })
    },
    // El paso de revisión se da por cumplido sólo cuando firmaron todos los
    // validadores del flujo, no con la primera firma.
    reviewedDone () {
      if (this.validatorSteps.length > 0) return this.validatorSteps.every(step => step.done)
      return this.histSteps.reviewed.length > 0 || this.isCompleted
    },
    // Una solicitud completada ya recorrió todo el flujo aunque progress no
    // traiga un movimiento por cada paso (el backend no registra la revisión).
    // El tab es la fuente del estatus: el listado viene filtrado por status_id.
    isCompleted () {
      return this.statusTag === 'completed'
    },
    // Columnas del seguimiento.
    // 'Completada' no forma parte del flujo de la solicitud, por eso no aparece.
    historySteps () {
      return [
        { key: 'created', text: this.$t('pettyCash.progress.created'), done: this.histSteps.created.length > 0 || this.isCompleted },
        { key: 'sented', text: this.$t('pettyCash.progress.sented'), done: this.histSteps.sented.length > 0 || this.isCompleted },
        // Verde hasta que todo el flujo de validación queda firmado.
        { key: 'reviewed', text: this.$t('pettyCash.progress.reviewed'), done: this.reviewedDone },
        { key: 'approved', text: this.$t('pettyCash.progress.approved'), done: this.histSteps.approved.length > 0 || this.isCompleted }
      ]
    },
    // Una vez aprobada ya no queda ningún validador pendiente, haya o no
    // movimiento de cada uno.
    isApproved () {
      return this.histSteps.approved.length > 0 || this.isCompleted
    },
    formTitle () {
      return this.editedIndex === -1 ? this.$t('pettyCash.requestPettyCash') : this.$t('pettyCash.requestPettyCashEdit')
    },
    rules () {
      return this.$validationRules()
    }
  },
  watch: {
    settings () {
      this.filterCurrency()
    },
    '$store.state.userLogged' () {
      this.init()
    }
  },
  created () {
    this.init()
  },
  methods: {
    // userLogged llega asíncrono, por eso el arranque se repite desde el watch:
    // hasta que hay empresa se puede saber si el módulo está disponible.
    init () {
      this.setLoggedUser()
      if (!this.$store.state.userLogged.company) return
      if (!this.applyFeaturePettyCashRequests()) {
        this.$router.push({ name: 'DashboardPage' })
        return
      }
      this.getUsers()
      this.getProjects()
      this.get()
    },
    // Catálogo de empleados del select; se pide una sola vez por carga de vista.
    getUsers () {
      this.$emit('getUsers', { context: this })
    },
    // Catálogo de proyectos del select; se pide una sola vez por carga de vista.
    getProjects () {
      this.$emit('getProjects', { context: this })
    },
    // El módulo sólo existe para empresas con el feature PETTY_CASH_REQUESTS.
    applyFeaturePettyCashRequests () {
      const company = this.$store.state.userLogged.company

      if (company === undefined) {
        return false
      }

      const features = company[0].features || []

      if (features.find(x => x.name === 'PETTY_CASH_REQUESTS')) {
        return true
      }

      return false
    },
    // Nombre del empleado de la solicitud. El listado puede traerlo en user o
    // sólo como user_id, así que se resuelve contra el catálogo del select.
    employeeName (item) {
      if (item.user && item.user.name) return item.user.name
      const employee = this.employeeItems.find(x => x.id === item.user_id)
      return employee ? employee.name : ''
    },
    // Nombre del proyecto de la solicitud. De momento project_id puede no venir
    // (solicitudes anteriores al campo): en ese caso la celda queda vacía. Si
    // el listado no trae la relación se resuelve contra el catálogo del select.
    projectName (item) {
      if (item.project && item.project.name) return item.project.name
      if (!item.project_id) return ''
      const project = this.projects.find(x => x.id === item.project_id)
      return project ? project.name : ''
    },
    // Deja fijo al usuario logueado como dueño de la caja chica, tanto en el
    // formulario actual como en el objeto por defecto que usa close().
    setLoggedUser () {
      const userLogged = this.$store.state.userLogged
      if (!userLogged || !userLogged.id) return
      this.editedItem.core_user_id = userLogged.id
      this.defaultItem.core_user_id = userLogged.id
    },
    filterCurrency () {
      const foundCurrencySetting = this.settings.find(x => x.setting_type.name === 'st.currency' && x.company_id === this.$store.state.userLogged.company[0].id)
      this.currencySetting = foundCurrencySetting || { value: { c_Moneda: 'MXN' } }
      this.tagMoneda = this.currencySetting.value.c_Moneda
    },
    changeSort (value) {
      if (this.pagination.sortBy === value) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = value
    },
    validate () {
      this.errors = {}
      if (this.$refs.form.validate()) {
        this.save()
      }
    },
    // Normaliza el estatus de texto que llega en progress ('Creada', 'Enviada',
    // ...) para no depender de acentos ni del género usado por el backend.
    statusKey (status) {
      if (!status) return ''
      const clean = status.toString().trim().toLowerCase()
        .replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i')
        .replace(/ó/g, 'o').replace(/ú/g, 'u')
      const map = {
        creada: 'created',
        creado: 'created',
        enviada: 'sented',
        enviado: 'sented',
        revisada: 'reviewed',
        revisado: 'reviewed',
        validada: 'reviewed',
        validado: 'reviewed',
        aprobada: 'approved',
        aprobado: 'approved',
        depositada: 'deposited',
        depositado: 'deposited',
        rechazada: 'rejected',
        rechazado: 'rejected'
      }
      return map[clean] || ''
    },
    // El estatus vigente es el del último movimiento (el de mayor id), no el
    // orden en que venga el arreglo.
    lastProgress (item) {
      const progress = (item && item.progress) || []
      if (progress.length === 0) return null
      return progress.reduce((prev, current) => (prev.id > current.id ? prev : current))
    },
    // Bandera de rechazo: sólo si el último movimiento es un rechazo. Los
    // rechazos anteriores no cuentan, la solicitud ya siguió su curso.
    isRejected (item) {
      const last = this.lastProgress(item)
      return last !== null && this.statusKey(last.status) === 'rejected'
    },
    // Motivo capturado por quien rechazó; si no lo hay, sólo se anuncia el
    // rechazo.
    rejectedMessage (item) {
      const last = this.lastProgress(item)
      if (last === null) return ''
      return last.comment
        ? this.$t('pettyCash.rejectReason') + ': "' + last.comment + '"'
        : this.$t('pettyCash.requestPettyCashRejected')
    },
    // El seguimiento se arma con la info que ya trae el listado (id, monto,
    // descripción, fecha y progress); lo único que se pide es el flujo de
    // validación del solicitante para saber quién falta por firmar.
    watchHistory (item) {
      this.itemHistory = Object.assign({}, item)
      this.validators = []
      this.approvers = []
      this.histLoading = true
      this.$emit('getWorkflowValidatorApprover', {
        context: this,
        user_id: item.user && item.user.id ? item.user.id : item.user_id
      })
      this.historyDialog = true
    },
    // Paso al que pertenece un movimiento. 'Creada' y 'Enviada' son del
    // solicitante y sí llegan con su estatus; los demás se resuelven por quién
    // firmó, porque el estatus que manda el backend para la revisión no
    // corresponde a ningún paso del seguimiento y se perdían.
    progressStepKey (item) {
      const key = this.statusKey(item.status)
      // El rechazo y el depósito los firma un validador o el aprobador, pero no
      // son pasos del flujo: se sacan antes de resolver por quién firmó, si no
      // el depósito se acreditaría al aprobador y su nombre saldría dos veces.
      if (key === 'created' || key === 'sented' || key === 'rejected' || key === 'deposited') return key
      if (this.validators.some(x => this.matchValidator(x, item.user_id))) return 'reviewed'
      if (this.isApproverMovement(item)) return 'approved'
      return key
    },
    // El paso lo puede firmar el validador o su sustituto.
    matchValidator (validator, userId) {
      if (!userId) return false
      if (validator.validator && validator.validator.user_id === userId) return true
      return !!(validator.substitutes && validator.substitutes.user_id === userId)
    },
    isApproverMovement (item) {
      if (!item.user_id) return false
      return this.approvers.some(x => (x.users || []).some(
        user => user.id === item.user_id || user.user_id === item.user_id
      ))
    },
    // progress sólo trae el user_id. Creada y Enviada son siempre del
    // solicitante; revisada y aprobada se resuelven contra el flujo para no
    // acreditarle al solicitante una firma que no es suya.
    progressUserName (progress, stepKey) {
      if (progress.user && progress.user.name) return progress.user.name

      if (stepKey === 'created' || stepKey === 'sented') {
        return this.itemHistory.user ? this.itemHistory.user.name : ''
      }

      const validator = this.validators.find(x => x.validator && x.validator.user_id === progress.user_id)
      if (validator) return validator.validator.user.name

      const substitute = this.validators.find(x => x.substitutes && x.substitutes.user_id === progress.user_id)
      if (substitute) return substitute.substitutes.user.name

      const approver = this.approvers.find(x => (x.users || []).some(
        user => user.id === progress.user_id || user.user_id === progress.user_id
      ))
      if (approver) return this.approverName(approver)

      // El último paso lo firma el aprobador: si el flujo sólo tiene uno, es él.
      if (stepKey === 'approved' && this.approvers.length === 1) return this.approverName(this.approvers[0])

      return ''
    },
    approverName (approver) {
      return approver.users && approver.users.length > 0 ? approver.users[0].name : ''
    },
    // Si no se pudo resolver el nombre se deja sólo la fecha del movimiento.
    progressLabel (progress, stepKey) {
      const name = this.progressUserName(progress, stepKey)
      return name ? name + ' - ' + progress.created_at : progress.created_at
    },
    // Alta: limpia primero para que no queden datos de una edición anterior.
    openCreate () {
      this.close()
      this.createDialog = true
    },
    // Reutiliza el modal de alta: tipo y empleado quedan fijos (deshabilitados)
    // —el empleado se precarga con el de la solicitud— y proyecto, descripción
    // y monto llegan precargados y editables.
    editItem (item) {
      this.close()
      this.editedIndex = this.pettyCash.indexOf(item)
      this.editedItem = Object.assign({}, this.editedItem, {
        id: item.id,
        core_user_id: item.user && item.user.id ? item.user.id : (item.user_id || this.editedItem.core_user_id),
        project_id: item.project && item.project.id ? item.project.id : (item.project_id || null),
        description: item.description,
        amount: item.amount
      })
      this.createDialog = true
    },
    save () {
      this.loading = true

      if (this.editedIndex > -1) return this.$emit('put', {item: this.editedItem, context: this})

      this.$emit('post', {item: this.editedItem, context: this})
    },
    // El registro del listado ya es la solicitud: su id es el que consume el
    // endpoint de borrado, no hay que bajar a small_box.
    removePetty (item) {
      this.removedItem = Object.assign({}, this.defaultRemoved, {
        id: item.id,
        core_user_id: this.$store.state.userLogged.id,
        description: item.description,
        amount: item.amount
      })
      this.removeDialog = true
    },
    deletePetty (item) {
      this.loading = true
      this.$emit('deletePetty', {context: this, item: item})
    },
    // Confirmación antes de arrancar el flujo: una vez enviada, la solicitud
    // deja de estar en creadas y ya no se puede editar ni eliminar.
    sendValidation (item) {
      this.validatedItem = Object.assign({}, this.defaultValidated, {
        id: item.id,
        description: item.description,
        amount: item.amount
      })
      this.validationDialog = true
    },
    startValidation (item) {
      this.loading = true
      this.$emit('startValidation', {context: this, item: item})
    },
    // Se usa tanto al cancelar como al terminar un alta/edición: deja el
    // formulario en blanco para que la siguiente apertura no arrastre datos.
    close () {
      this.loading = false
      this.createDialog = false
      this.removeDialog = false
      this.historyDialog = false
      this.validationDialog = false
      this.editedIndex = -1
      this.errors = {}
      // El ref sólo existe si el diálogo de alta ya se renderizó.
      if (this.$refs.form) this.$refs.form.resetValidation()
      this.editedItem = Object.assign({}, this.defaultItem)
      this.removedItem = Object.assign({}, this.defaultRemoved)
      this.validatedItem = Object.assign({}, this.defaultValidated)
      this.itemHistory = Object.assign({}, this.defaultHistory)
      this.histLoading = false
      this.validators = []
      this.approvers = []
    },
    // Cambio de tab. Todos los estatus consultan el mismo endpoint; los
    // statusIds del tab viajan en el evento para filtrar en el store.
    getPettyCashByStatus (tab) {
      if (this.loadingItems === true || this.statusTag === tab.status) return
      this.statusTag = tab.status
      this.statusIds = tab.statusIds
      this.userSearch = ''
      this.pettyCash = []
      this.loadingItems = true
      this.refresh()
    },
    get () {
      this.$emit('get', {
        context: this,
        company_id: this.$store.state.userLogged.company[0].id,
        status: this.statusTag,
        statusIds: this.statusIds
      })
    },
    refresh () {
      this.$emit('refresh', {
        context: this,
        company_id: this.$store.state.userLogged.company[0].id,
        status: this.statusTag,
        statusIds: this.statusIds
      })
    }
  }
}
</script>

<style scoped>
.v-data-table {
  overflow-x: auto !important;
  max-width: 100% !important;
}

.currency-field {
  display: flex;
  align-items: center;
}

.currency-tag {
  margin-left: 5px;
}

/* Columna del seguimiento ya cubierta por la solicitud. */
.hist-steps {
  background-color: #63b225 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/requestPettyCash.component.vue